import { Component } from "@theme/component";

/**
 * ProductVariants
 *
 * “Product variants” 块的自定义元素。
 * 将多个独立产品（例如每个颜色一个产品）关联起来，使其表现得像变体选择器，
 * 选择某个选项后跳转到对应产品页面。
 *
 * 渲染结构参考： blocks/product-variants.liquid
 *
 * 跳转方式：
 *   - 按钮 / 色块样式：使用原生 <a href> 链接完成跳转，无需 JS（渐进增强，JS 失效也可用）。
 *   - 下拉样式：通过主题组件框架的声明式事件 `on:change="/navigate"` 调用本组件的
 *     navigate 方法完成跳转（参考 assets/component.js 的事件委托机制）。
 *
 * @extends {Component}
 */
class ProductVariants extends Component {
  /**
   * 根据下拉框当前选中项的值（产品 URL）跳转。
   *
   * @param {Event} event - change 事件，target 为 <select>。
   */
  navigate(event) {
    const target = event.target;

    if (target instanceof HTMLSelectElement && target.value) {
      window.location.href = target.value;
    }
  }
}

if (!customElements.get("product-variants")) {
  customElements.define("product-variants", ProductVariants);
}
